import { ESuggestedProductType, ESuggestedProductViewId } from 'core/model/enums/catalog.enum';
import {
  ICatalogSortOption,
  TSectionsSuggestionConfig,
  TSuggestedSectionsTypes,
} from 'core/model/interfaces/catalogues.interface';

export const CATALOGUE_SORT_OPTIONS: Array<ICatalogSortOption> = [
  {
    id: 'name',
    content: 'A-Z',
    value: 'name:asc',
  },
  {
    id: 'lowerPrice',
    content: 'Menor precio',
    value: 'price:asc',
  },
  {
    id: 'higherPrice',
    content: 'Mayor precio',
    value: 'price:desc',
  },
];

export const DEFAULT_CATALOG_PAGE = 1;
export const DEFAULT_CATALOG_ITEMS_PER_PAGE = 12;
export const MAX_SUGGESTED_ITEMS_PER_PAGE = 24;
export const PRODUCT_COUNTER_CLICKING_DELAY = 1000;

export const suggestedSectionsNames: Map<TSuggestedSectionsTypes, string> = new Map([
  ['I', 'Imperdonables'],
  ['P', 'Potenciadores'],
  ['S', 'Surtido Ideal'],
]);

export const DEBOUNCE_TIME_TO_FETCH_SUGGESTION_PRODUCTS = 10000;

export const SUGGESTIONS_TITLES: Record<TSuggestedSectionsTypes, string> = {
  I: 'Tus productos favoritos de siempre',
  P: 'Otros clientes están comprando estos productos',
  S: 'El surtido ideal de productos para tu negocio',
};

export const SECTIONS_SUGGESTION_CONFIG: TSectionsSuggestionConfig = {
  [ESuggestedProductViewId.homepage]: [ESuggestedProductType.I],
  [ESuggestedProductViewId.shoppingCart]: [ESuggestedProductType.P],
  [ESuggestedProductViewId.internalPage]: [ESuggestedProductType.I, ESuggestedProductType.P, ESuggestedProductType.S],
};

export const SUGGESTION_SECTION_TITLES: Record<ESuggestedProductType, string> = {
  [ESuggestedProductType.I]: SUGGESTIONS_TITLES.I,
  [ESuggestedProductType.P]: SUGGESTIONS_TITLES.P,
  [ESuggestedProductType.S]: SUGGESTIONS_TITLES.S,
};
